










































































































import {Component, Mixins, Watch} from 'vue-property-decorator'
import {MixinRouteMatch} from '@/components/mixins/MixinRouteMatch'
import {GithubOrganization} from '@/model/resource/GithubOrganization'
import {GithubOrganizationCollection} from '@/model/collection/GithubOrganizationCollection'
import {ListGithubOrganizationSchema} from '@/schema/resource/GithubOrganization/ListGithubOrganizationSchema'

@Component({
  components: {},
})
export default class ListGithubOrganizationView extends Mixins(
  MixinRouteMatch
) {
  schema = new ListGithubOrganizationSchema()
  collection = new GithubOrganizationCollection()

  async created() {
    if (this.hasQueryParams) {
      this.updateObjectFromRoute(this.collection)
    }

    await this.$await.run('hardQuery', () => this.collection.queryAsPage())
  }

  async removeItem(item: GithubOrganization) {
    await this.$dialog.remove(item)
    await item.removeGithubOrganization()
    await this.collection.queryAsPage()
  }

  goToPersistView(item: GithubOrganization) {
    this.$nav.pushByName('editGithubOrganization', item.$id)
  }

  @Watch('collection', {deep: true})
  collectionEvent() {
    this.updateRouteFromObject(this.collection)
  }
}
